import { render, staticRenderFns } from "./fzorganhistory.vue?vue&type=template&id=60d8b74d&scoped=true&"
import script from "./fzorganhistory.vue?vue&type=script&lang=js&"
export * from "./fzorganhistory.vue?vue&type=script&lang=js&"
import style0 from "./fzorganhistory.vue?vue&type=style&index=0&id=60d8b74d&scoped=true&lang=css&"
import style1 from "./fzorganhistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8b74d",
  null
  
)

export default component.exports